
<mat-dialog-content class="dialog">
  <app-dialog-header [title]="title$ | async"></app-dialog-header>
  <div class="dialog-container">
    <div class="sidebar">
      <app-new-project-sidebar></app-new-project-sidebar>
      <button class="iconf-btn-blank minh40" (click)="goBack()">Back</button>
    </div>

    <div class="content">
      <router-outlet name="new-project-dialog" (activate)="onRouterItemChange($event)"></router-outlet>
    </div>
  </div>
</mat-dialog-content>
